(function () {
  'use strict';

  var CFG = window.HEZI || {};
  var moneyFormat = CFG.moneyFormat || '{{amount}} ₪';
  var FREE_SHIP = CFG.freeShipping || 0;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/, Number(amount).toLocaleString('he-IL'))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toLocaleString('he-IL'))
      .replace(/NIS|ILS/g, '₪');
  }

  function imgSized(url, w) {
    if (!url) return url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  /* ---------- toast ---------- */
  var toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('on');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('on'); }, 2600);
  }

  /* ---------- header shadow ---------- */
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 8);
    }, { passive: true });
  }

  /* ---------- mobile menu ---------- */
  var mnav = document.getElementById('MobileNav');
  var burger = document.querySelector('.burger');
  var drawerBg = document.getElementById('drawerBg');
  function closeMobile() {
    if (mnav) mnav.classList.remove('on');
    syncBg();
  }
  if (burger && mnav) {
    burger.addEventListener('click', function () {
      mnav.classList.add('on');
      syncBg();
    });
    var mclose = mnav.querySelector('.mnav-close');
    if (mclose) mclose.addEventListener('click', closeMobile);
  }

  /* ---------- favorites (localStorage wishlist) ---------- */
  var FAV_KEY = 'hezi_favorites';
  function favGet() {
    try { return JSON.parse(localStorage.getItem(FAV_KEY) || '[]'); } catch (e) { return []; }
  }
  function favSet(list) {
    try { localStorage.setItem(FAV_KEY, JSON.stringify(list)); } catch (e) {}
    favUpdateCount(list);
  }
  function favUpdateCount(list) {
    list = list || favGet();
    document.querySelectorAll('[data-fav-count]').forEach(function (el) {
      el.textContent = list.length;
      el.style.display = list.length ? '' : 'none';
    });
  }
  function favHas(handle) {
    return favGet().some(function (f) { return f.handle === handle; });
  }
  function favToggle(data) {
    var list = favGet();
    var i = list.findIndex(function (f) { return f.handle === data.handle; });
    if (i > -1) { list.splice(i, 1); } else { list.unshift(data); }
    favSet(list);
    return i === -1;
  }
  function favSync() {
    document.querySelectorAll('[data-fav-handle]').forEach(function (btn) {
      btn.classList.toggle('on', favHas(btn.dataset.favHandle));
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-fav-handle]');
    if (!btn) return;
    e.preventDefault();
    var added = favToggle({
      handle: btn.dataset.favHandle,
      title: btn.dataset.favTitle,
      url: btn.dataset.favUrl,
      price: btn.dataset.favPrice,
      image: btn.dataset.favImage
    });
    document.querySelectorAll('[data-fav-handle="' + btn.dataset.favHandle + '"]').forEach(function (b) {
      b.classList.toggle('on', added);
      var lbl = b.querySelector('.fav-label');
      if (lbl) lbl.textContent = added ? 'נשמר במועדפים ✓' : 'הוספה למועדפים';
    });
    if (added) toast('נוסף למועדפים ♥');
  });
  favUpdateCount();
  favSync();

  /* favorites page renderer */
  var favGrid = document.querySelector('[data-fav-grid]');
  if (favGrid) {
    var list = favGet();
    if (!list.length) {
      favGrid.innerHTML = '<div class="fav-empty"><h2>אין עדיין מועדפים</h2><p>לחצי על הלב ♥ על מוצרים שאהבת, והם יופיעו כאן.</p><a class="btn dark" href="/collections/all">לכל הדגמים</a></div>';
    } else {
      favGrid.innerHTML = '<div class="pgrid stagger in">' + list.map(function (f) {
        var img = f.image ? '<img src="' + esc(f.image) + '" alt="' + esc(f.title) + '" loading="lazy">' : '<div class="ph" data-mono="LS"></div>';
        return '<article class="pcard"><div class="pimg"><a href="' + esc(f.url) + '">' + img + '</a>' +
          '<button type="button" class="fav-btn on" data-fav-handle="' + esc(f.handle) + '" data-fav-title="' + esc(f.title) + '" data-fav-url="' + esc(f.url) + '" data-fav-price="' + esc(f.price) + '" data-fav-image="' + esc(f.image) + '" aria-label="הסרה ממועדפים">' +
          '<svg viewBox="0 0 24 24"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg></button>' +
          '</div><div class="pinfo"><div class="pname"><a href="' + esc(f.url) + '">' + esc(f.title) + '</a></div><div class="pprice">' + esc(f.price) + '</div></div></article>';
      }).join('') + '</div>';
    }
  }

  /* ---------- mobile menu accordion groups ---------- */
  document.querySelectorAll('.mnav-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = btn.closest('.mnav-group');
      var open = group.classList.toggle('open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ---------- cart drawer ---------- */
  var drawer = document.getElementById('CartDrawer');
  var dbody = document.getElementById('CartDrawerBody');
  var dsub = document.getElementById('CartDrawerSubtotal');
  var rowItems = document.getElementById('CartRowItems');
  var itemsTotalEl = document.getElementById('CartItemsTotal');
  var rowDisc = document.getElementById('CartRowDisc');
  var discAmountEl = document.getElementById('CartDiscAmount');
  var nudgeEl = document.getElementById('CartDealNudge');
  var counts = document.querySelectorAll('.cart-count');
  var spWrap = document.getElementById('ShipProgress');
  var spLabel = document.getElementById('ShipProgressLabel');
  var spFill = document.getElementById('ShipProgressFill');
  var upWrap = document.getElementById('CartUpsell');
  var upBody = document.getElementById('CartUpsellItems');
  var upCache = {}; /* seed product_id -> recommended products */
  var saveEl = document.getElementById('CartSave');
  var caCache = {}; /* product handle -> { variantId: {price, cap} } */

  function syncBg() {
    var anyOpen = (drawer && drawer.classList.contains('on')) || (mnav && mnav.classList.contains('on'));
    if (drawerBg) drawerBg.classList.toggle('on', anyOpen);
    document.documentElement.classList.toggle('no-scroll', anyOpen);
  }

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('on');
    syncBg();
  }
  function closeDrawer() {
    if (drawer) drawer.classList.remove('on');
    syncBg();
  }

  var prevCount = null;
  function setCount(n) {
    counts.forEach(function (c) {
      c.textContent = n;
      c.classList.toggle('show', n > 0);
      if (prevCount !== null && n > prevCount) {
        c.classList.remove('pop');
        void c.offsetWidth;
        c.classList.add('pop');
      }
    });
    prevCount = n;
  }

  function renderProgress(total) {
    if (!spWrap || !FREE_SHIP) return;
    spWrap.hidden = false;
    var pct = Math.min(100, Math.round(total / FREE_SHIP * 100));
    spFill.style.width = pct + '%';
    if (total >= FREE_SHIP) {
      spWrap.classList.add('done');
      spLabel.textContent = 'יש! המשלוח עלינו — ההזמנה זכאית למשלוח חינם';
    } else {
      spWrap.classList.remove('done');
      spLabel.textContent = 'עוד ' + formatMoney(FREE_SHIP - total) + ' ומגיע לך משלוח חינם';
    }
  }

  function drawUpsell(products, inCart) {
    var list = (products || []).filter(function (p) {
      return p && p.available && inCart.indexOf(p.id) === -1;
    }).slice(0, 3);
    if (!list.length) { if (upWrap) upWrap.hidden = true; return; }
    upBody.innerHTML = list.map(function (p) {
      var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
      if (!v) return '';
      var img = p.featured_image || (p.images && p.images[0]);
      var imgTag = img ? '<img src="' + esc(imgSized(img, 140)) + '" alt="" loading="lazy">' : '<div class="dph"></div>';
      return '<a class="cu-item" href="' + esc(p.url) + '">' +
        imgTag +
        '<div class="cu-in"><div class="cu-name">' + esc(p.title) + '</div>' +
        '<div class="cu-price">' + formatMoney(v.price) + '</div></div>' +
        '<button type="button" class="cu-add" data-up-add="' + v.id + '" aria-label="הוספה לעגלה">+</button>' +
        '</a>';
    }).join('');
    upWrap.hidden = false;
  }

  function renderUpsell(cart) {
    if (!upWrap || !upBody) return;
    if (!cart.items.length) { upWrap.hidden = true; return; }
    var seed = cart.items[0].product_id;
    var inCart = cart.items.map(function (i) { return i.product_id; });
    if (upCache[seed]) { drawUpsell(upCache[seed], inCart); return; }
    var base = '/recommendations/products.json?limit=6&product_id=' + seed + '&intent=';
    fetch(base + 'complementary').then(function (r) { return r.json(); }).then(function (d) {
      var prods = (d && d.products) || [];
      if (prods.length) return prods;
      return fetch(base + 'related').then(function (r) { return r.json(); }).then(function (d2) { return (d2 && d2.products) || []; });
    }).then(function (prods) {
      upCache[seed] = prods;
      drawUpsell(prods, inCart);
    }).catch(function () { upWrap.hidden = true; });
  }

  /* "בקנייה זו חסכת" — total saving vs the original (compare-at) prices */
  function computeSavings(cart) {
    if (!saveEl) return;
    if (!cart.items.length) { saveEl.hidden = true; return; }
    var handles = {};
    cart.items.forEach(function (it) { handles[it.handle] = true; });
    var uniq = Object.keys(handles);
    Promise.all(uniq.map(function (h) {
      if (caCache[h]) return Promise.resolve(caCache[h]);
      return fetch('/products/' + encodeURIComponent(h) + '.js')
        .then(function (r) { return r.json(); })
        .then(function (pd) {
          var m = {};
          (pd.variants || []).forEach(function (v) { m[v.id] = { price: v.price, cap: v.compare_at_price }; });
          caCache[h] = m; return m;
        }).catch(function () { caCache[h] = {}; return {}; });
    })).then(function (maps) {
      var byHandle = {};
      uniq.forEach(function (h, i) { byHandle[h] = maps[i]; });
      var save = 0;
      cart.items.forEach(function (it) {
        var v = (byHandle[it.handle] || {})[it.variant_id];
        if (v && v.cap && v.cap > v.price) save += (v.cap - v.price) * it.quantity;
      });
      if (save > 0) {
        saveEl.innerHTML = '<span>בקנייה זו חסכת</span><strong>' + formatMoney(save) + '</strong>';
        saveEl.hidden = false;
      } else {
        saveEl.hidden = true;
      }
    });
  }

  function renderCart(cart) {
    setCount(cart.item_count);
    if (dsub) dsub.textContent = formatMoney(cart.total_price);
    if (rowItems && rowDisc) {
      if (cart.total_discount > 0) {
        if (itemsTotalEl) itemsTotalEl.textContent = formatMoney(cart.original_total_price);
        if (discAmountEl) discAmountEl.textContent = '−' + formatMoney(cart.total_discount);
        rowItems.hidden = false;
        rowDisc.hidden = false;
      } else {
        rowItems.hidden = true;
        rowDisc.hidden = true;
      }
    }
    if (nudgeEl) {
      if (cart.item_count > 0 && cart.item_count % 2 === 1) {
        nudgeEl.innerHTML = '<strong>הוסיפי עוד זוג</strong> — והזול מביניהם ב-20% הנחה!';
        nudgeEl.classList.remove('active');
        nudgeEl.hidden = false;
      } else if (cart.total_discount > 0) {
        nudgeEl.innerHTML = '<strong>מבצע זוג שני הופעל</strong> — חסכת ' + formatMoney(cart.total_discount);
        nudgeEl.classList.add('active');
        nudgeEl.hidden = false;
      } else {
        nudgeEl.hidden = true;
      }
    }
    renderProgress(cart.total_price);
    renderUpsell(cart);
    computeSavings(cart);
    if (!dbody) return;
    if (!cart.items.length) {
      dbody.innerHTML = '<div class="dempty">העגלה ריקה כרגע.<br><br><a class="btn dark" href="/collections/all">לכל הדגמים</a></div>';
      return;
    }
    dbody.innerHTML = cart.items.map(function (item) {
      var img = item.image
        ? '<img src="' + esc(imgSized(item.image, 160)) + '" alt="">'
        : '<div class="dph"></div>';
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      var lineSave = item.original_line_price - item.final_line_price;
      var priceHtml, dealTag = '';
      if (lineSave > 0) {
        priceHtml = '<s>' + formatMoney(item.original_line_price) + '</s> <em>' + formatMoney(item.final_line_price) + '</em>';
        dealTag = '<span class="ditem-deal">הנחת מוצר שני · חסכת ' + formatMoney(lineSave) + '</span>';
      } else {
        priceHtml = formatMoney(item.final_line_price);
      }
      return '<div class="ditem" data-key="' + esc(item.key) + '">' +
        img +
        '<div class="din">' +
          '<div class="dname">' + esc(item.product_title) + '</div>' +
          (variant ? '<div class="dvar">' + esc(variant) + '</div>' : '') +
          '<div class="dprice">' + priceHtml + '</div>' +
          dealTag +
          '<div class="dqty">' +
            '<button type="button" data-qty="-1" aria-label="הפחתה">−</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" data-qty="1" aria-label="הוספה">+</button>' +
          '</div>' +
          '<button type="button" class="dremove">הסרה</button>' +
        '</div>' +
      '</div>';
    }).join('');
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      renderCart(cart);
      return cart;
    });
  }

  function changeItem(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      renderCart(cart);
      return cart;
    });
  }

  window.HeziCart = {
    add: function (variantId, quantity) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return fetchCart();
      }).then(function () { openDrawer(); });
    },
    open: openDrawer
  };

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-cart-open]');
    if (openBtn) { e.preventDefault(); fetchCart(); openDrawer(); return; }

    var closeBtn = e.target.closest('[data-cart-close]');
    if (closeBtn) { closeDrawer(); return; }

    var qtyBtn = e.target.closest('.ditem [data-qty]');
    if (qtyBtn) {
      var item = qtyBtn.closest('.ditem');
      var qty = parseInt(item.querySelector('.dqty span').textContent, 10) + parseInt(qtyBtn.dataset.qty, 10);
      changeItem(item.dataset.key, Math.max(0, qty));
      return;
    }

    var removeBtn = e.target.closest('.ditem .dremove');
    if (removeBtn) {
      changeItem(removeBtn.closest('.ditem').dataset.key, 0);
      return;
    }

    /* cart upsell quick add (button sits inside an <a>, block navigation) */
    var upAdd = e.target.closest('[data-up-add]');
    if (upAdd) {
      e.preventDefault();
      e.stopPropagation();
      upAdd.disabled = true;
      window.HeziCart.add(upAdd.dataset.upAdd, 1)
        .then(function () { toast('נוסף לעגלה ✓'); })
        .catch(function () { toast('לא ניתן להוסיף את המוצר כרגע'); })
        .finally(function () { upAdd.disabled = false; });
      return;
    }

    /* quick add — single variant */
    var quick = e.target.closest('button.quick[data-variant-id]');
    if (quick) {
      e.preventDefault();
      quick.disabled = true;
      window.HeziCart.add(quick.dataset.variantId, 1)
        .then(function () { toast('נוסף לעגלה ✓'); })
        .catch(function () { toast('לא ניתן להוסיף את המוצר כרגע'); })
        .finally(function () { quick.disabled = false; });
      return;
    }

    /* quick add — multi variant: open size chooser */
    var quickMulti = e.target.closest('button.quick[data-quick-sizes]');
    if (quickMulti) {
      e.preventDefault();
      var card = quickMulti.closest('.pcard');
      var box = card.querySelector('.qsizes');
      if (box) box.classList.toggle('on');
      return;
    }

    var qsBtn = e.target.closest('.qsizes button[data-variant-id]');
    if (qsBtn) {
      e.preventDefault();
      qsBtn.disabled = true;
      window.HeziCart.add(qsBtn.dataset.variantId, 1)
        .then(function () {
          toast('נוסף לעגלה ✓');
          var box = qsBtn.closest('.qsizes');
          if (box) box.classList.remove('on');
        })
        .catch(function () { toast('המידה הזו אזלה בינתיים'); })
        .finally(function () { qsBtn.disabled = false; });
      return;
    }

    /* close open size choosers when clicking outside */
    if (!e.target.closest('.qsizes') && !e.target.closest('.quick')) {
      document.querySelectorAll('.qsizes.on').forEach(function (b) { b.classList.remove('on'); });
    }
  });

  if (drawerBg) drawerBg.addEventListener('click', function () { closeDrawer(); closeMobile(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); closeMobile(); }
  });

  fetchCart();

  /* ---------- scroll reveal ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.01, rootMargin: '0px 0px -5% 0px' });
    document.querySelectorAll('.reveal,.stagger').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal,.stagger').forEach(function (el) { el.classList.add('in'); });
  }
  /* safety net: never leave content hidden, whatever happens */
  setTimeout(function () {
    document.querySelectorAll('.reveal:not(.in),.stagger:not(.in)').forEach(function (el) {
      el.classList.add('in');
    });
  }, 2500);

  /* ---------- product form ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (root) {
    var dataEl = root.querySelector('[data-product-json]');
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var invEl = root.querySelector('[data-inventory-json]');
    var inventory = invEl ? JSON.parse(invEl.textContent) : {};
    var idInput = root.querySelector('input[name="id"]');
    var priceEl = root.querySelector('[data-price]');
    var atcBtn = root.querySelector('[data-atc]');
    var qtyInput = root.querySelector('[data-qty-input]');
    var galMain = root.querySelector('[data-gal-main]');
    var galThumbs = root.querySelectorAll('[data-gal-thumb]');
    var galDots = root.querySelectorAll('[data-gal-dot]');
    var galImages = Array.prototype.map.call(galThumbs, function (t) {
      return { src: t.dataset.src, id: String(t.dataset.imageId) };
    });
    var galCurrent = 0;

    function galSetActive(index) {
      Array.prototype.forEach.call(galThumbs, function (t, i) { t.classList.toggle('active', i === index); });
      Array.prototype.forEach.call(galDots, function (d, i) { d.classList.toggle('active', i === index); });
    }
    /* swap the main image src directly — always works, no scroll/snap involved */
    function galShow(index, bringIntoView) {
      if (!galMain || index < 0 || index >= galImages.length) return;
      galCurrent = index;
      if (galMain.getAttribute('src') !== galImages[index].src) galMain.src = galImages[index].src;
      galSetActive(index);
      if (bringIntoView && window.innerWidth < 900) {
        galMain.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
    function galIndexForImageId(id) {
      for (var i = 0; i < galImages.length; i++) { if (galImages[i].id === String(id)) return i; }
      return -1;
    }

    var lowstockEl = root.querySelector('[data-lowstock]');
    var bisEl = root.querySelector('[data-bis]');
    var stickyBar = document.querySelector('[data-sticky-atc]');

    function selectedOptions() {
      return Array.prototype.map.call(root.querySelectorAll('.opt-group'), function (g) {
        var sel = g.querySelector('.opt-pill.selected');
        return sel ? sel.dataset.value : null;
      });
    }

    function findVariant(opts) {
      /* product with a single default variant (no size/colour options) */
      if (!opts.length || product.variants.length === 1) {
        return product.variants.filter(function (v) { return v.available; })[0] || product.variants[0];
      }
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    /* mark unavailable values: a value is unavailable if no AVAILABLE variant
       matches it combined with the selections in the OTHER option groups */
    function markAvailability() {
      var sel = selectedOptions();
      root.querySelectorAll('.opt-group').forEach(function (g, gi) {
        g.querySelectorAll('.opt-pill').forEach(function (pill) {
          var ok = product.variants.some(function (v) {
            if (!v.available) return false;
            if (v.options[gi] !== pill.dataset.value) return false;
            return v.options.every(function (o, i) {
              return i === gi || sel[i] === null || o === sel[i];
            });
          });
          pill.classList.toggle('unavailable', !ok);
        });
      });
    }

    function updateState(scrollToImage) {
      var sel = selectedOptions();
      markAvailability();

      /* live-update the chosen value labels */
      root.querySelectorAll('.opt-group .val').forEach(function (v, i) {
        v.textContent = sel[i] || '';
      });

      /* preview the image for the chosen colour, even before a size is picked */
      var preview = product.variants.find(function (v) {
        return v.featured_image && v.options.every(function (o, i) { return sel[i] === null || o === sel[i]; });
      });
      if (preview && preview.featured_image) {
        var gp = galIndexForImageId(preview.featured_image.id);
        if (gp > -1) {
          /* only scroll the image into view when a COLOUR was chosen — not on size */
          var offp = !!scrollToImage && galMain && galMain.getBoundingClientRect().bottom < 40;
          galShow(gp, offp);
        }
      }

      var sBtn0 = stickyBar ? stickyBar.querySelector('button') : null;

      /* require every option to be actively chosen before add-to-cart */
      var complete = sel.every(function (o) { return o !== null; });
      if (!complete) {
        idInput.value = '';
        if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = 'בחירת מידה וצבע'; }
        if (sBtn0) sBtn0.disabled = true;
        if (bisEl) bisEl.hidden = true;
        return;
      }

      var variant = findVariant(sel);
      if (!variant) {
        idInput.value = '';
        if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = 'הצירוף אינו זמין'; }
        if (sBtn0) sBtn0.disabled = true;
        return;
      }
      idInput.value = variant.id;
      var priceHtml = variant.compare_at_price > variant.price
        ? '<em>' + formatMoney(variant.price) + '</em> <s>' + formatMoney(variant.compare_at_price) + '</s>'
        : formatMoney(variant.price);
      if (priceEl) priceEl.innerHTML = priceHtml;
      if (stickyBar) {
        var sp = stickyBar.querySelector('.sa-price');
        if (sp) sp.innerHTML = priceHtml;
        if (sBtn0) sBtn0.disabled = !variant.available;
      }
      if (atcBtn) {
        atcBtn.disabled = !variant.available;
        atcBtn.textContent = variant.available ? atcBtn.dataset.labelAdd : 'אזל מהמלאי';
      }
      if (bisEl) {
        if (!variant.available && CFG.wa) {
          var msg = encodeURIComponent('היי! אשמח לדעת מתי "' + product.title + '" (' + (variant.title || '') + ') חוזר למלאי');
          bisEl.querySelector('a').href = 'https://wa.me/' + CFG.wa + '?text=' + msg;
          bisEl.hidden = false;
        } else {
          bisEl.hidden = true;
        }
      }
    }

    root.querySelectorAll('.opt-pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        pill.closest('.opt-pills').querySelectorAll('.opt-pill').forEach(function (p) {
          p.classList.remove('selected');
        });
        pill.classList.add('selected');
        var grp = pill.closest('.opt-group');
        var fromColor = !!(grp && grp.classList.contains('is-color'));
        updateState(fromColor);
      });
    });

    root.querySelectorAll('[data-qty-change]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.max(1, v + parseInt(btn.dataset.qtyChange, 10));
      });
    });

    /* gallery controls: thumbnails + dots swap the main image */
    Array.prototype.forEach.call(galThumbs, function (t) {
      t.addEventListener('click', function () { galShow(parseInt(t.dataset.index, 10)); });
    });
    Array.prototype.forEach.call(galDots, function (d) {
      d.addEventListener('click', function () { galShow(parseInt(d.dataset.index, 10)); });
    });
    /* mobile: swipe the main image to move between photos */
    if (galMain && galImages.length > 1) {
      var swEl = root.querySelector('[data-gal-swipe]') || galMain;
      var swX = 0, swY = 0;
      swEl.addEventListener('touchstart', function (e) { swX = e.touches[0].clientX; swY = e.touches[0].clientY; }, { passive: true });
      swEl.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - swX, dy = e.changedTouches[0].clientY - swY;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4) {
          var next = galCurrent + (dx < 0 ? 1 : -1);
          if (next < 0) next = galImages.length - 1;
          if (next >= galImages.length) next = 0;
          galShow(next);
        }
      }, { passive: true });
    }

    function submitAdd() {
      if (!atcBtn) return;
      if (!idInput.value) { toast('נא לבחור מידה וצבע'); return; }
      atcBtn.disabled = true;
      window.HeziCart.add(idInput.value, parseInt(qtyInput ? qtyInput.value : 1, 10) || 1)
        .then(function () { toast('נוסף לעגלה ✓'); })
        .catch(function (err) { toast(err && err.description ? err.description : 'לא ניתן להוסיף את המוצר כרגע'); })
        .finally(function () { atcBtn.disabled = false; });
    }

    var form = root.querySelector('form[data-type="add-to-cart-form"]');
    if (form && atcBtn) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        submitAdd();
      });
    }

    /* sticky mobile ATC */
    if (stickyBar && 'IntersectionObserver' in window) {
      var anchor = root.querySelector('.qty-row');
      if (anchor) {
        var sio = new IntersectionObserver(function (entries) {
          var below = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
          stickyBar.classList.toggle('on', below);
          document.body.classList.toggle('has-sticky-atc', below);
        }, { threshold: 0 });
        sio.observe(anchor);
      }
      var sBtn = stickyBar.querySelector('button');
      if (sBtn) sBtn.addEventListener('click', submitAdd);
    }

    /* size guide modal */
    var sgLink = root.querySelector('[data-size-guide-open]');
    var sgModal = document.querySelector('[data-size-guide]');
    if (sgLink && sgModal) {
      sgLink.addEventListener('click', function (e) {
        e.preventDefault();
        sgModal.classList.add('on');
      });
      sgModal.addEventListener('click', function (e) {
        if (e.target === sgModal || e.target.closest('[data-sg-close]')) sgModal.classList.remove('on');
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') sgModal.classList.remove('on');
      });
    }

    updateState();
  });

  /* ---------- rotating announcement ---------- */
  var anMsgs = document.querySelectorAll('[data-announce] .an-msg');
  if (anMsgs.length > 1) {
    var anIdx = 0;
    setInterval(function () {
      anMsgs[anIdx].classList.remove('on');
      anIdx = (anIdx + 1) % anMsgs.length;
      anMsgs[anIdx].classList.add('on');
    }, 3800);
  }

  /* ---------- hero stage tilt ---------- */
  var hero = document.querySelector('.hero');
  var stageCards = hero ? hero.querySelectorAll('.stage-card') : [];
  if (hero && stageCards.length &&
      window.matchMedia('(pointer:fine)').matches &&
      !window.matchMedia('(prefers-reduced-motion:reduce)').matches) {
    var raf = null;
    hero.addEventListener('mousemove', function (e) {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var r = hero.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        hero.classList.add('tilting');
        stageCards.forEach(function (c) {
          c.style.setProperty('--tx', (x * -14) + 'px');
          c.style.setProperty('--ty', (y * -10) + 'px');
        });
      });
    });
    hero.addEventListener('mouseleave', function () {
      hero.classList.remove('tilting');
      stageCards.forEach(function (c) {
        c.style.removeProperty('--tx');
        c.style.removeProperty('--ty');
      });
    });
  }

  /* ---------- live search ---------- */
  var sov = document.querySelector('[data-search-overlay]');
  if (sov) {
    var sovInput = sov.querySelector('[data-live-search]');
    var sovResults = sov.querySelector('[data-search-results]');
    var sovTimer = null;

    function openSearch() {
      sov.classList.add('on');
      document.documentElement.classList.add('no-scroll');
      setTimeout(function () { sovInput.focus(); }, 120);
    }
    function closeSearch() {
      sov.classList.remove('on');
      document.documentElement.classList.remove('no-scroll');
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-search-open]')) { e.preventDefault(); openSearch(); }
      if (e.target.closest('[data-search-close]') || e.target === sov) closeSearch();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeSearch();
    });

    sovInput.addEventListener('input', function () {
      clearTimeout(sovTimer);
      var q = sovInput.value.trim();
      if (q.length < 2) { sovResults.innerHTML = ''; return; }
      sovResults.innerHTML = '<div class="sov-empty">מחפש…</div>';
      sovTimer = setTimeout(function () {
        /* Shopify predictive search (suggest.json) is unreliable on new stores — it
           returns nothing until indexed. Pull from the regular search page instead,
           which always works, and parse the product cards from it. */
        fetch('/search?q=' + encodeURIComponent(q) + '&type=product')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var cards = Array.prototype.slice.call(doc.querySelectorAll('.pcard')).slice(0, 6);
            if (!cards.length) {
              sovResults.innerHTML = '<div class="sov-empty">לא מצאנו התאמה — נסי מילה אחרת</div>';
              return;
            }
            sovResults.innerHTML = cards.map(function (c) {
              var a = c.querySelector('.pname a') || c.querySelector('a[href*="/products/"]');
              var url = a ? a.getAttribute('href') : '#';
              var nameEl = c.querySelector('.pname');
              var name = nameEl ? nameEl.textContent.trim() : (a ? a.textContent.trim() : '');
              var priceEl = c.querySelector('.pprice');
              var price = priceEl ? priceEl.textContent.replace(/\s+/g, ' ').trim() : '';
              var imgEl = c.querySelector('.pimg img');
              var src = imgEl ? (imgEl.getAttribute('src') || imgEl.getAttribute('data-src') || '') : '';
              var img = src ? '<img src="' + esc(src) + '" alt="" loading="lazy">' : '<div class="dph" style="width:48px;height:64px"></div>';
              return '<a class="sov-item" href="' + esc(url) + '">' + img +
                '<div><div class="si-name">' + esc(name) + '</div>' +
                '<div class="si-price">' + esc(price) + '</div></div></a>';
            }).join('') +
            '<a class="sov-all" href="/search?q=' + encodeURIComponent(q) + '&type=product">לכל התוצאות ←</a>';
          })
          .catch(function () { sovResults.innerHTML = '<div class="sov-empty">לא ניתן לחפש כרגע</div>'; });
      }, 250);
    });
  }

  /* ---------- collection sort ---------- */
  var sortSelect = document.getElementById('SortBy');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  /* ---------- cart page qty (no full reload) ---------- */
  document.querySelectorAll('[data-cart-line]').forEach(function (line) {
    function refresh(cart) {
      var item = cart.items.find(function (i) { return i.key === line.dataset.cartLine; });
      var subEls = document.querySelectorAll('[data-cart-subtotal]');
      subEls.forEach(function (el) { el.textContent = formatMoney(cart.total_price); });
      if (!item) { line.remove(); if (!cart.item_count) window.location.reload(); return; }
      line.querySelector('.dqty span').textContent = item.quantity;
      var lt = line.querySelector('.line-total');
      if (lt) lt.textContent = formatMoney(item.final_line_price);
    }
    line.querySelectorAll('[data-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var qty = parseInt(line.querySelector('.dqty span').textContent, 10) + parseInt(btn.dataset.qty, 10);
        changeItem(line.dataset.cartLine, Math.max(0, qty)).then(refresh);
      });
    });
    var rm = line.querySelector('.dremove');
    if (rm) rm.addEventListener('click', function () {
      changeItem(line.dataset.cartLine, 0).then(refresh);
    });
  });

  /* ---------- frequently bought together (product page) ---------- */
  var fbt = document.getElementById('Fbt');
  if (fbt) {
    var fbtSeed = fbt.dataset.productId;
    var fbtBase = '/recommendations/products.json?limit=6&product_id=' + fbtSeed + '&intent=';
    fetch(fbtBase + 'complementary').then(function (r) { return r.json(); }).then(function (d) {
      var prods = (d && d.products) || [];
      if (prods.length) return prods;
      return fetch(fbtBase + 'related').then(function (r) { return r.json(); }).then(function (d2) { return (d2 && d2.products) || []; });
    }).then(function (prods) {
      var recs = (prods || []).filter(function (p) { return p && p.available && String(p.id) !== String(fbtSeed); }).slice(0, 2);
      if (recs.length) fbtBuild(recs);
    }).catch(function () {});
  }

  function fbtRow(img, name, price, variantId, locked) {
    return '<label class="fbt-line">' +
      '<input type="checkbox" data-fbt-check checked' + (locked ? ' disabled' : '') +
        ' data-variant="' + esc(variantId) + '" data-price="' + price + '">' +
      '<span class="fbt-box"></span>' +
      (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '<span class="dph"></span>') +
      '<span class="fbt-nm">' + esc(name) + '</span>' +
      '<span class="fbt-pr">' + formatMoney(price) + '</span>' +
    '</label>';
  }

  function fbtBuild(recs) {
    var basePrice = parseInt(fbt.dataset.price, 10) || 0;
    var rows = fbtRow(fbt.dataset.image, fbt.dataset.title + ' (המוצר הזה)', basePrice, '', true);
    recs.forEach(function (p) {
      var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
      if (!v) return;
      var img = p.featured_image || (p.images && p.images[0]);
      rows += '<div class="fbt-plus" aria-hidden="true">+</div>';
      rows += fbtRow(imgSized(img, 160), p.title, v.price, v.id, false);
    });
    fbt.innerHTML =
      '<div class="fbt-t">קונים יחד</div>' +
      '<div class="fbt-list">' + rows + '</div>' +
      '<div class="fbt-foot"><div class="fbt-total"><span>סה"כ</span><strong data-fbt-total></strong></div>' +
      '<button type="button" class="btn dark" data-fbt-add>הוסיפי הכל לעגלה</button></div>';
    fbt.hidden = false;
    fbtTotal();
    fbt.addEventListener('change', function (e) { if (e.target.matches('[data-fbt-check]')) fbtTotal(); });
    fbt.querySelector('[data-fbt-add]').addEventListener('click', fbtAddAll);
  }

  function fbtTotal() {
    var t = 0;
    fbt.querySelectorAll('[data-fbt-check]').forEach(function (c) { if (c.checked) t += parseInt(c.dataset.price, 10) || 0; });
    var el = fbt.querySelector('[data-fbt-total]');
    if (el) el.textContent = formatMoney(t);
  }

  function fbtAddAll() {
    var btn = fbt.querySelector('[data-fbt-add]');
    btn.disabled = true;
    var curInput = document.querySelector('form[data-type="add-to-cart-form"] [name="id"]');
    var items = [{ id: curInput ? curInput.value : fbt.dataset.variantId, quantity: 1 }];
    fbt.querySelectorAll('[data-fbt-check]').forEach(function (c) {
      if (c.checked && c.dataset.variant) items.push({ id: c.dataset.variant, quantity: 1 });
    });
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return fetchCart();
    }).then(function () {
      openDrawer();
      toast('נוסף לעגלה ✓');
    }).catch(function () {
      toast('לא ניתן להוסיף את הפריטים כרגע');
    }).finally(function () { btn.disabled = false; });
  }
})();
